import { Button as MuiButton } from "@mui/material";
import React, { useEffect, useState } from "react";
import { lsGet, Model, UseForm } from "hooks";
import { action, API, controller } from "api";
import SwitchReg from "./SwitchReg";
import OpenReg from "./OpenReg";

const RegFormBody = ({ outletId, regs, setShowForm, onSuccess }) => {
  const activeReg = lsGet("activeReg");
  const { SellRegisterMdl } = Model();
  const [selRegDtls, setSelRegDtls] = useState(activeReg);
  const {
    values,
    setValues,
    errors,
    setErrors,
    handleInpChg,
    resetFormControls,
  } = UseForm(SellRegisterMdl);

  useEffect(() => {
    activeReg &&
      setValues((j) => ({
        ...j,
        registerId: activeReg.registerId || 0,
        outletId: activeReg.outletId,
      }));
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSelReg = (registerId) => {
    setValues((j) => ({ ...j, outletId, registerId }));
  };

  // Get Selected Register Details
  useEffect(() => {
    if (values && values.registerId) {
      API(controller.SellReg + action.GetActiveReg).getById(
        values.registerId,
        (res) => {
          if (res && res.status === 200) {
            setSelRegDtls(res.result);
          }
        }
      );
    } else if (!activeReg) setSelRegDtls();

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.registerId]);

  return (
    <div className="grid gap-5 p-[15px]">
      <div>
        {errors.registerId && (
          <span className="text-red-500 text-[13px] font-medium pl-[5px]">
            {errors.registerId}
          </span>
        )}
        <div className="flex justify-around flex-row flex-wrap	gap-3">
          {regs.map((reg, ind) => (
            <MuiButton
              key={ind + "reg"}
              onClick={() => handleSelReg(reg.id)}
              varinat="text"
              className="h-[100px] flex-grow !min-w-[150px] !text-[16px]"
              sx={{
                borderBottom: `3px solid ${
                  reg.id === (values && values.registerId)
                    ? "var(--primary-color)"
                    : "var(--white-color)"
                }`,
              }}
            >
              <div className="grid items-center">
                <span className="font-medium text-[18px] leading-snug">
                  {reg.name}
                </span>
                {/* <span className="text-[12px]">Register Status</span> */}
              </div>
            </MuiButton>
          ))}
        </div>
      </div>

      {selRegDtls && selRegDtls.status !== 2 ? (
        <SwitchReg {...{ setShowForm, selRegDtls, onSuccess }} />
      ) : (
        <OpenReg
          {...{
            values,
            errors,
            setShowForm,
            setErrors,
            handleInpChg,
            onSuccess,
            resetFormControls,
          }}
        />
      )}
    </div>
  );
};

export default RegFormBody;
